import React, { useEffect, useState } from "react";
import {
  Autocomplete,
  TextField,
  ToggleButton,
  ToggleButtonGroup,
} from "@mui/material";
import { FormikProps } from "formik";
import Grid2 from "@mui/material/Grid2"; // استفاده از Grid2
import { useMutation } from "@tanstack/react-query";
import { useAuth } from "src/context/auth";
import { IAutoCompleteLabelValue } from "src/interface/enum/GeneralType";
import { getRoutes } from "src/utilities/routes";
import { TypeUser } from "src/interface/enum/TypeUser";
import { IAppUser } from "src/interface/IUser";
import { useNotifications } from "@toolpad/core/useNotifications";
import { ITransaction } from "src/interface/ITransaction";
import { DatePicker } from "@mui/x-date-pickers";
import { handleChange } from "src/utilities";

// ساخت schema برای اعتبارسنجی با yup

const TransactionForm = ({
  formik,
  customerRef,
}: {
  formik: FormikProps<ITransaction>;
  customerRef?: string;
}) => {
  const { user } = useAuth();
  const Routes = getRoutes();
  const [getCustomers, setGetCustomers] = useState<IAutoCompleteLabelValue[]>(
    []
  );
  const [displayAmount, setDisplayAmount] = useState<string>("");
  const notifications = useNotifications();
  const { mutateAsync: GetListCustomers, isPending: isCustomersLoading } =
    useMutation({
      mutationFn: async () => {
        const response = await fetch(
          Routes.UsersRoutes + "getByRole/" + TypeUser.CUSTOMER,
          {
            method: "GET",
            headers: {
              Authorization: `Bearer ${user?.token}`,
              Aceept: "application/json",
            },
          }
        );
        return await response.json();
      },

      onSuccess: (responseData: IAppUser[]) => {
        if (responseData && responseData.length > 0) {
          setGetCustomers(
            responseData
              .filter((item: IAppUser) => item.parentRef === null)
              .map((item: IAppUser) => ({
                label:
                  item.lName +
                  " " +
                  item.fName +
                  " " +
                  item.coName +
                  " " +
                  item.caseNumber,
                value: item.id,
              }))
          );
        }
      },
      onError: (error) => {
        notifications.show("خطا در دریافت اطلاعات", {
          severity: "error",
          autoHideDuration: 3000,
        });
        console.log(error);
      },
    });

  useEffect(() => {
    user?.token && GetListCustomers();
  }, [user?.token]);

  // تنظیم customerRef در formik وقتی از خارج ارسال می‌شود
  useEffect(() => {
    if (customerRef && customerRef !== formik.values.customerRef) {
      formik.setFieldValue("customerRef", customerRef);
      formik.setFieldTouched("customerRef", true);
    }
  }, [customerRef, formik]);

  // به‌روزرسانی Autocomplete وقتی customerRef یا getCustomers تغییر می‌کند
  useEffect(() => {
    if (customerRef && getCustomers.length > 0) {
      const customer = getCustomers.find((c) => c.value === customerRef);
      if (customer && formik.values.customerRef !== customerRef) {
        formik.setFieldValue("customerRef", customerRef);
        formik.setFieldTouched("customerRef", true);
      }
    }
  }, [customerRef, getCustomers, formik]);

  // همگام‌سازی displayAmount با formik.values.amount فقط در زمان بارگذاری اولیه
  // useEffect(() => {
  //   if (
  //     formik.values.amount !== undefined &&
  //     formik.values.amount !== null &&
  //     formik.values.amount > 0
  //   ) {
  //     setDisplayAmount(formik.values.amount.toLocaleString());
  //   } else {
  //     setDisplayAmount("");
  //   }
  // }, []); // فقط یک بار در زمان بارگذاری اولیه اجرا شود

  return (
    <>
      <Grid2 container spacing={1} marginY={1}>
        <Grid2 size={6}>
          <Autocomplete
            isOptionEqualToValue={(option, value) =>
              option.value === value.value
            }
            value={
              getCustomers.length > 0 && formik.values.customerRef
                ? getCustomers.find(
                    (s) => s.value === formik.values.customerRef
                  ) || null
                : null
            }
            disabled={!!customerRef}
            onChange={(event: any, newValue: any) => {
              formik.setFieldValue("customerRef", newValue?.value || undefined);
            }}
            loading={isCustomersLoading}
            options={getCustomers ?? []}
            fullWidth
            renderInput={(params) => (
              <TextField
                error={
                  formik.touched.customerRef &&
                  Boolean(formik.errors.customerRef)
                }
                helperText={
                  (formik.touched.customerRef &&
                    formik.errors.customerRef) as boolean
                }
                {...params}
                label="مشتری"
                placeholder="مشتری"
              />
            )}
          />
        </Grid2>
        <Grid2 size={3}>
          <TextField
            name="amount2"
            value={formik.values.amount2}
            onChange={(event) => {
              const value = event.target.value;

              const numericValue = (value || "").replace(/[^\d]/g, "");
              formik.setFieldValue(
                "amount2",
                parseInt(numericValue, 10).toLocaleString() ?? 0
              );
            }}
            // onBlur={() => {
            //   const numericValue = (displayAmount || "").replace(/[^\d]/g, "");
            //   const amountValue = numericValue ? parseInt(numericValue) : 0;

            //   if (numericValue) {
            //     setDisplayAmount(parseInt(numericValue).toLocaleString());
            //   } else {
            //     setDisplayAmount("");
            //   }
            //   //formik.handleBlur({ target: { name: "amount" } });
            // }}
            label="مبلغ"
            placeholder="مبلغ"
            error={formik.touched.amount && Boolean(formik.errors.amount)}
            helperText={
              (formik.touched.amount && formik.errors.amount) as boolean
            }
            variant="outlined"
            fullWidth
          />
        </Grid2>
        <Grid2 size={3}>
          <DatePicker
            sx={{ width: "100%" }}
            label="تاریخ تراکنش"
            onChange={(date: Date | null) =>
              formik.setFieldValue("transactionDate", date)
            }
            value={
              (formik.values.transactionDate &&
                new Date(formik.values.transactionDate)) ||
              null
            }
            //defaultValue={new Date()}
          />
        </Grid2>
      </Grid2>
      <Grid2 container spacing={1} marginY={1}>
        <Grid2 size={12}>
          <TextField
            multiline
            rows={2}
            {...formik.getFieldProps("description")} // استفاده از ویژگی‌های فرمیک
            label="شرح"
            placeholder="شرح"
            error={
              formik.touched.description && Boolean(formik.errors.description)
            }
            helperText={
              (formik.touched.description &&
                formik.errors.description) as boolean
            }
            variant="outlined"
            fullWidth
          />
        </Grid2>
      </Grid2>
      <ToggleButtonGroup
        fullWidth
        size="small"
        color="primary"
        value={formik.values.isDebit}
        exclusive
        onChange={(event: any, newValue: any) =>
          handleChange(event, newValue, "isDebit", formik)
        }
        aria-label="Platform"
      >
        <ToggleButton value={true}>بدهکار</ToggleButton>
        <ToggleButton value={false}>بستانکار</ToggleButton>
      </ToggleButtonGroup>
    </>
  );
};

export default TransactionForm;
